module.exports = __webpack_public_path__ + "media/images/partners/airtel-1-281e92100d185ec0c4d4acfc0435eaf7.png";